var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FlyerlineModal",
        { ref: "modalRef", attrs: { name: _vm.modalName } },
        [
          _c(
            "div",
            [
              _c("AddressBookTable", {
                attrs: { addresses: _vm.addresses },
                on: { select: _vm.handleSelection, edit: _vm.handleEdit },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn w-100@until-medium float-right",
                  on: { click: _vm.handleNew },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("translate")("versandaufteilungAddressbuchAdd")
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("AddressBookAddAddress", { ref: "addAddressModal" }),
      _vm._v(" "),
      _c("AddressBookUpdateAddress", { ref: "updateAddressModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }